// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weather-widget {
  aspect-ratio: 1;
  position: relative;
  max-height: 225px;
  min-height: 225px;
}
.weather-widget img {
  width: 42px;
  height: 42px;
  position: absolute;
  top: 0;
  right: 2px;
}
.weather-widget .weather-container {
  display: flex;
  flex-direction: column;
}
.weather-widget .weather-container .weather-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.weather-widget .weather-container .weather-title h5 {
  font-weight: 700;
  margin: 0;
}
.weather-widget .weather-container .temperature {
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  max-width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}
.weather-widget .weather-container .temperature .cold {
  color: #1e90ff;
}
.weather-widget .weather-container .temperature .warm {
  color: #ffa500;
}
.weather-widget .weather-container .temperature .hot {
  color: #ff4500;
}
.weather-widget .weather-container .weather-details {
  display: flex;
  flex-direction: column;
  gap: 3px;
  color: #666;
}
.weather-widget .weather-container .weather-details div {
  font-size: 12px;
}

ion-modal .location-toggle-container {
  margin-bottom: 20px;
}
ion-modal .location-toggle-container ion-toggle {
  font-weight: 600;
  display: block;
  margin: 0 auto;
  --track-background-checked: #ed143d;
  width: 100%;
}
ion-modal .location-toggle-container .location-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  color: #666;
  font-size: 14px;
  margin-top: 10px;
}
ion-modal .location-toggle-container .location-loading ion-spinner {
  --color: #ed143d;
}
ion-modal .location-toggle-container .location-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  color: #ed143d;
  font-size: 14px;
  background: #ffe6e6;
  border-radius: 8px;
  margin-top: 10px;
}
ion-modal ion-input {
  border-radius: 10px;
  background: white;
  padding: 0 10px 5px !important;
}
ion-modal ion-list {
  margin-block: 10px;
  background: #efefef;
  gap: 10px;
  display: flex;
  flex-direction: column;
}
ion-modal ion-list .suggestion-item {
  background: white;
  border-radius: 10px;
  display: flex;
  padding-block: 5px;
  align-items: center;
}
ion-modal ion-list .suggestion-item .suggestion-item-icon {
  padding: 10px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ed143d;
}
ion-modal ion-list .suggestion-item .suggestion-item-text {
  flex: 1;
  display: flex;
  flex-direction: column;
}
ion-modal ion-list .suggestion-item .suggestion-item-text .suggestion-item-text-region {
  font-size: 12px;
  color: #666;
}
ion-modal ion-list .suggestion-item .suggestion-item-text .suggestion-item-text-name {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/widgets/weather-widget/weather-widget.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AACJ;AACI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AACR;AACI;EACI,aAAA;EACA,sBAAA;AACR;AAAI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAER;AADQ;EACI,gBAAA;EACA,SAAA;AAGZ;AAEI;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AAAR;AACQ;EACI,cAAA;AACZ;AAEU;EACE,cAAA;AAAZ;AAGU;EACE,cAAA;AADZ;AAII;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAFR;AAIQ;EACI,eAAA;AAFZ;;AASI;EACI,mBAAA;AANR;AAOQ;EACI,gBAAA;EACA,cAAA;EACA,cAAA;EACA,mCAAA;EACA,WAAA;AALZ;AAQQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AANZ;AAQY;EACI,gBAAA;AANhB;AAUQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AARZ;AAYI;EACI,mBAAA;EACA,iBAAA;EACA,8BAAA;AAVR;AAYM;EACE,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AAVR;AAWQ;EACI,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AATZ;AAUY;EACI,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AARhB;AAUY;EACI,OAAA;EACA,aAAA;EACA,sBAAA;AARhB;AAUgB;EACI,eAAA;EACA,WAAA;AARpB;AAUgB;EACI,eAAA;AARpB","sourcesContent":[".weather-widget {\n    aspect-ratio: 1;\n    position: relative;\n    max-height :225px;\n    min-height: 225px;\n\n    img {\n        width: 42px;\n        height: 42px;\n        position: absolute;\n        top: 0;\n        right: 2px;\n    }\n    .weather-container {\n        display: flex;\n        flex-direction: column;\n    .weather-title {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        h5 {\n            font-weight: 700;\n            margin: 0;\n\n        }\n      \n    }\n    .temperature {\n        font-size: 16px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        font-weight: 600;\n        max-width: 100%;\n        margin:0;\n        display: flex;\n        flex-direction: column;\n        .cold {\n            color: #1e90ff; \n          }\n          \n          .warm {\n            color: #ffa500; \n          }\n          \n          .hot {\n            color: #ff4500; \n          }\n    }\n    .weather-details {\n        display: flex;\n        flex-direction: column;\n        gap: 3px;\n        color: #666;\n  \n        div {\n            font-size: 12px;\n        }\n    }\n  }\n}\n\n  ion-modal {\n    .location-toggle-container{ \n        margin-bottom: 20px;\n        ion-toggle{\n            font-weight: 600;\n            display: block;\n            margin: 0 auto;\n            --track-background-checked: #ed143d;\n            width: 100%;       \n        }\n        \n        .location-loading {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            padding: 10px;\n            color: #666;\n            font-size: 14px;\n            margin-top: 10px;\n            \n            ion-spinner {\n                --color: #ed143d;\n            }\n        }\n        \n        .location-error {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            padding: 10px;\n            color: #ed143d;\n            font-size: 14px;\n            background: #ffe6e6;\n            border-radius: 8px;\n            margin-top: 10px;\n        }\n    }\n    \n    ion-input {\n        border-radius: 10px;\n        background: white;\n        padding: 0 10px 5px !important;\n    }\n      ion-list {\n        margin-block: 10px;\n        background: #efefef;\n        gap:10px;\n        display: flex;\n        flex-direction: column;\n        .suggestion-item {\n            background: white;\n            border-radius: 10px;\n            display: flex;\n            padding-block: 5px;\n            align-items: center;\n            .suggestion-item-icon {\n                padding: 10px;\n                font-size: 20px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: #ed143d;\n            }\n            .suggestion-item-text {\n                flex:1;\n                display: flex;\n                flex-direction: column;\n                // gap:5px;\n                .suggestion-item-text-region {\n                    font-size: 12px;\n                    color: #666;\n                }\n                .suggestion-item-text-name {\n                    font-size: 14px;\n                }   \n            }   \n        }\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
